import styled from 'styled-components';

const filterModalStyle = {
  content: {
    borderRadius: 0,
    borderStyle: 'none',
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    left: 0,
    padding: 0,
    right: 0,
    top: 90,
  },
};

const FiltersWrapper = styled.div`
  flex: 1 1 auto;
  position: relative;
  overflow-y: auto;
`;

const TitleWrapper = styled.div`
  text-align: center;
`;

const BackImage = styled.img`
  position: absolute;
  height: 16px;
  width: 16px;
  left: 0;
`;

export { BackImage, FiltersWrapper, TitleWrapper, filterModalStyle };
